import React from 'react'
import { CircularProgress } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';
import '../Status.scss';
import './StatusStepCard.scss';

export default function StatusStepCard(props){

  const { active, stepNumber, stepTitle, stepStatusLabel, showSpinner, showCheckmark } = props;

  const activeColor = active ? '#333333' : '#999999';

  return (
    <div className="statusSection" style={{'--active-color': activeColor}}>
      <div className={'statusHeader'}>
        <div className={`circleNumber`}>
          {stepNumber}
        </div>

        <p className="stepTitle">{stepTitle}</p>

        {stepStatusLabel && (
          <div className='time'>
            {showSpinner && <CircularProgress size={18} />}
            {showCheckmark && <CheckCircleOutlined size={18} />}
            <span className='status-label'>{stepStatusLabel}</span>          </div>
        )}
      </div>

      {active &&
        <div className="statusStepContainer">
          {props.children}
        </div>
      }
    </div>
  )
}
